import { addWeeks, endOfWeek, format, startOfWeek, subWeeks } from 'date-fns';
import { setFilters } from '../../../pages/financialAdvisor/appointments/slice.ts';
import { useAppDispatch, useAppSelector } from '../../redux/hook.ts';

export const useWeekCalendar = () => {
    const dispatch = useAppDispatch();
    const filters = useAppSelector(state => state.appointments.filters['week']);

    const changeInterval = (action: 'next' | 'prev' | 'today') => {
        let week = new Date(filters.fromDate!);
        let fromDateTime = format(startOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
        let toDateTime = format(endOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
        if (action === 'next') {
            week = addWeeks(week, 1);
            fromDateTime = format(startOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
            toDateTime = format(endOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")

        } else if (action === 'prev') {
            week = subWeeks(week, 1);
            fromDateTime = format(startOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
            toDateTime = format(endOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
        } else {
            week = new Date();
            fromDateTime = format(startOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
            toDateTime = format(endOfWeek(week, {weekStartsOn: 1}), "yyyy-MM-dd")
        }
        dispatch(setFilters({ period: 'week', filters: { fromDate: fromDateTime, toDate: toDateTime } }));
    }

    return {
        filters,
        changeInterval
    };
};
